import { Flex } from "antd";
import styled from "styled-components";
import borders from "theme/borders.module.scss";

export const StyledFlex = styled(Flex)`
    input, .ant-input-affix-wrapper-lg, .ant-input-number {
        border-radius: ${borders.borderRadiusSM};
    }
`;